<script>
import { normalizeDateFormat } from "../../../../../../../helpers/dateHelper";
import NameComponent from "./NameComponent.vue";
import DateComponent from "./DateComponent.vue";

export default {
  name: "SearchNotarialCaseComponent",
  components: {
    NameComponent,
    DateComponent
  },
  props: {
    testator: {
      type: Object,
      required: true
    },
    searchSubmitHandler: {
      type: Function,
      required: true
    }
  },
  setup() {

    const normalizeDateFormatHandler = (e) => {
      e.target.value = normalizeDateFormat(e.target.value);
    };

    return {
      normalizeDateFormatHandler
    }
  }
}
</script>

<template>
  <div>
    <span class="group-block-title">Данные свидетельства о смерти</span>
    <name-component
      v-model:name="testator.name"
      :search-submit-handler="searchSubmitHandler"
    />
    <date-component
      :normalize-date-format-handler="normalizeDateFormatHandler"
      :search-submit-handler="searchSubmitHandler"
      v-model:date="testator.dateDeath"
    />
  </div>
</template>

<style scoped>

.group-block-title {
  position: absolute;
  top: -8px;
  left: 10px;
  background-color: #efefef;
  font-size: 10px;
  text-transform: uppercase;
  display: inline-block;
  padding: 2px;
  color: #000000;
}

.mx-datepicker {
  width: 100%;
}

label {
  display: block;
}

.form-group {
  margin-bottom: 0;
  position: relative;
}

.row {
  margin-bottom: 15px;
}

.row:last-child {
  margin-bottom: 0;
}

</style>
